import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router';

import { Icon } from '@/components/orno/icon';
import { translateDynamic } from '@/i18n';

import type { NavItem } from '../routing';

/** The navigation entries, sorted, as orno's nav items. */
export function Nav({ items, onNavigate }: { items: NavItem[]; onNavigate?: () => void }) {
  const { t } = useTranslation();
  const sorted = [...items].sort((a, b) => a.order - b.order);

  return (
    <nav aria-label={t('nav.label')} className="shell__rail-list app-nav">
      <ul className="app-nav__list">
        {sorted.map((item) => (
          <li key={item.to}>
            <NavLink
              to={item.to}
              end={item.end ?? false}
              onClick={onNavigate}
              className={({ isActive }) => (isActive ? 'nav-item on' : 'nav-item')}
            >
              <Icon name={item.icon} />
              {translateDynamic(t, item.ns, item.labelKey)}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
